export const NavbarButtonsSkeleton = () => {
  return (
    <div className="text-xs font-medium text-nowrap animate-pulse bg-gray-500 w-8 xl:w-24 h-8 rounded-sm">
      &nbsp;
    </div>
  )
}
